// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__S7ykT","name":"Header_name__FytHP","birthday":"Header_birthday__1Fpfj","skeleton":"Header_skeleton__2GlCP"};